import { render } from "./OddsCompanyFilter.vue?vue&type=template&id=114fd246&scoped=true"
import script from "./OddsCompanyFilter.vue?vue&type=script&lang=js"
export * from "./OddsCompanyFilter.vue?vue&type=script&lang=js"

import "./OddsCompanyFilter.vue?vue&type=style&index=0&id=114fd246&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114fd246"]])

export default __exports__